$(".variant-picker__wrapper input[type=radio]").change((function() {

  var variantVal = $(this).val();
  var variantPolicy = $(this).attr('data-vpolicy');
  var variantQty = $(this).attr('data-vqty');
  console.log(variantVal);
  
  // klavio form display on soldout variant and policy deny
  if($(this).hasClass("sold-out") && variantPolicy == 'deny'){
      $('.app_inner_wrp.klavio_waitlist_form').addClass('soldout__variant');
  }else {
    $('.app_inner_wrp.klavio_waitlist_form').removeClass('soldout__variant');
  }

  // show preorder button and custom info message pass variant nameon change
  if(variantPolicy == 'continue' && variantQty <= 0){
    $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    $('.custom_info_text_wrp').addClass('show_message');
    if(variantVal != 'Default Title'){
      var customInfo = $(this).closest(".product__form__wrapper").find('.custom_info_text_wrp p span.vartxt');
      if(customInfo && variantVal){
        customInfo.text(variantVal);
      }
    }
    setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
        $('span.atc_txxt').text(theme.strings.preorder);
      }
    },1000);
  }else{
    console.log($(this).hasClass("sold-out"), "aaaaaaaaaaaa");
    if($(this).hasClass("sold-out")){
      $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    }else{
       $('.custom_info_text_wrp').removeClass('show_message');
       $('.custom_ava_info_text_wrp').addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = $(this).closest(".product__form__wrapper").find('.custom_ava_info_text_wrp p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
     
  }

  // color swatch selected value assign to addon checkbox addon products
   var variantObj = $(this);
   console.log(variantObj);
   var addonSelectedVal = $(this).next().attr('data-myvariant');
   var addonSelectedImgVal = $(this).next().attr('data-myvariantimg');
   $(this).closest('.main_addon_wrp').find('input[type=checkbox]').val(addonSelectedVal);
   $(this).closest('.main_addon_wrp').find('.product-addon_product__image__thumb').css('background-image', 'url(' + addonSelectedImgVal + ')');
   

  // product upsell id change on change
    var mySelectedVal = $(this).next().attr('data-myvariant');
    var mySelectedImgVal = $(this).next().attr('data-myvariantimg');
    var myvariantavailable = this.nextElementSibling.getAttribute('data-myvariantavailable');
    var form = this.closest('form.product-upsell__form');
    var btn = null;

    if (form) {
      btn = form.querySelector('.product-upsell__btn');
    }

    if (btn) {
      if (myvariantavailable === "false") {
        btn.classList.add("disabled");
      } else {
        btn.classList.remove("disabled");
      }
    }
    $(this).closest('form.product-upsell__form').find('input[name=id]').val(mySelectedVal);
    $(this).closest('.product-upsell__holder').find('.product-upsell__image__thumb').css('background-image', 'url(' + mySelectedImgVal + ')');

    // product grid quick add selected variant id change
    const $formEle = $(this).closest('form.product-upsell__form');
    const $btnEle = $formEle.find('.prdct_cart_quick_add_btn');
    const $mediEle = $(this).closest('.product-grid-item').find('.prdct_grid_img_asvariant');
    if($mediEle.length && mySelectedImgVal){
      $mediEle.css('background-image', 'url(' + mySelectedImgVal + ')');
    }
    if ($btnEle.length && $btnEle.attr('data-product-id') !== undefined) {
      $btnEle.attr('data-product-id', mySelectedVal);
    }
}));

// product upsell
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swatch__label").forEach(function (label) {
    if (label.dataset.myvariantavailable === "false") {
      const swatchButton = label.closest(".swatch__button");
      if (swatchButton) {
        const input = swatchButton.querySelector("input[type='radio']");
        if (input) {
          input.classList.add("sold-out");
        }
      }
    }
  });
});

// cart upsell bundle item variant id change
$(document).on("click", ".swatch__input--bundle + label", function () {
  console.log("Bundle swatch clicked");
  var variantId = $(this).data("variant-id");
  console.log("Variant ID:", variantId);
  var bundleWrapper = $(this).closest(".cart_upsell_bundle_item_inn");
  if (bundleWrapper.length && variantId) {
    bundleWrapper.find(".bundle-hidden-variant-id").val(variantId);
  }
});

$(document).ready(function(){
  setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
      $('span.atc_txxt').text(theme.strings.preorder);
    }
  },1000);
});


// bundle page swatch hide show message
$(document).ready(function () {
  $('.bundle-color-swatch .radio__fieldset .swatch__button').on('click', function() {
    var dataInfo = $(this).find('.swatch__label');
    var messageinfoAvailableSelector = $(this).closest('.bundle-builder').find('.custom_ava_info_text_wrp');
    var messageinfoSoldoutSelector = $(this).closest('.bundle-builder').find('.custom_info_text_wrp');
    var variantVal = dataInfo.attr('data-variant-title');
    var variantPolicy = dataInfo.attr('data-vpolicy');
    var variantQty = dataInfo.attr('data-vqty');
    

    // custom info message pass variant nameon change
    if(variantPolicy == 'continue' && variantQty <= 0){
      console.log(messageinfoAvailableSelector);
      console.log(messageinfoSoldoutSelector);
       messageinfoAvailableSelector.removeClass('show_avaiable_info');
       messageinfoSoldoutSelector.addClass('show_message');
      if(variantVal != 'Default Title'){
        var customInfo = messageinfoSoldoutSelector.find('p span.vartxt');
        if(customInfo && variantVal){
          customInfo.text(variantVal);
        }
      }
      
    }else{
        messageinfoSoldoutSelector.removeClass('show_message');
        messageinfoAvailableSelector.addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = messageinfoAvailableSelector.find('p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
    
  });
});



document.addEventListener("DOMContentLoaded", function () {

   // STEP 1 — Trigger click on the first subscription group radio (not one-time)

  //  setTimeout(function(){
  //    const firstGroup = document.querySelector('input[name="selling-plan-group"]:not([value=""])');
  //    if (firstGroup) {
  //      firstGroup.click(); 
  //    }
  //  },1000);


  // Listen for subscription plan changes
  document.querySelectorAll('[name="selling-plan-group"], [name="selling_plan"]').forEach(input => {

    
    input.addEventListener("change", function (event) {

      // Find correct bundle block
      const bundleWrapper = event.target.closest('.bundle-wrapper, .bundle-picker__wrapper');

      if (!bundleWrapper) return;

      // Read selected plan
      const selected = bundleWrapper.querySelector('input[name="selling_plan"]:checked');
      const planValue = selected ? selected.value : "";

      // Update hidden selling plan input inside this bundle
      const hiddenField = bundleWrapper.querySelector('.bundle-selling-plan');
      if (hiddenField) {
        hiddenField.value = planValue;
        console.log("Updated selling plan:", planValue);
      }
    });
  });

});



// saved amount badge subscription widget
document.addEventListener("DOMContentLoaded", function () {

  function getMaxSubscriptionSave() {
    let max = 0;

    document.querySelectorAll('input[name="selling_plan"][data-save-raw]').forEach(input => {
      const val = parseFloat(input.dataset.saveRaw);
      if (!isNaN(val)) {
        max = Math.max(max, val);
      }
    });

    return max;
  }

  function updateSaveBoxFromPlan(planInput) {
    const saveBox = document.querySelector('.saved_txt_plan');
    if (!saveBox) return;

    const save = planInput.dataset.save || '';

    if (save) {
      saveBox.textContent = `save: ${save}`;
      saveBox.classList.remove('hidden');
    } else {
      saveBox.textContent = '';
      saveBox.classList.add('hidden');
    }
  }

  function updateSaveBoxForOneTime() {
    const saveBox = document.querySelector('.saved_txt_plan');
    if (!saveBox) return;

    const maxSave = getMaxSubscriptionSave();

    if (maxSave > 0) {
      saveBox.textContent = `save: ${maxSave}%`;
      saveBox.classList.remove('hidden');
    } else {
      saveBox.textContent = '';
      saveBox.classList.add('hidden');
    }
  }

  /* --------------------
     SUBSCRIPTION PLAN CHANGE
  -------------------- */
  document.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
    radio.addEventListener('change', function () {
      updateSaveBoxFromPlan(this);
    });
  });

  /* --------------------
     PLAN GROUP CHANGE (One-time / Subscription)
  -------------------- */
  document.querySelectorAll('input[name="selling-plan-group"]').forEach(radio => {
    radio.addEventListener('change', function () {
      // One-time purchase → value is empty
      if (this.value === "") {
        updateSaveBoxForOneTime();
      }
    });
  });

  /* --------------------
     INITIAL LOAD
  -------------------- */
  const checkedPlan = document.querySelector('input[name="selling_plan"]:checked');
  if (checkedPlan) {
    updateSaveBoxFromPlan(checkedPlan);
  }

});



// 
// 
// 
// 
// 
// 
function syncSellingPlanGroupToAllBundles(groupId) {
  document.querySelectorAll('.bundle-wrapper').forEach((bundle, index) => {
    // skip first bundle (already clicked by user)
    if (index === 0) return;

    const groupRadio = bundle.querySelector(
      `input[type="radio"][name^="selling-plan-group-"][value="${groupId}"]`
    );

    if (groupRadio && !groupRadio.checked) {
      groupRadio.checked = true;
      groupRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

// function syncSellingPlanToAllBundles(planId) {
//   document.querySelectorAll('.bundle-wrapper').forEach((bundle, index) => {
//     if (index === 0) return;

//     const planRadio = bundle.querySelector(
//       `input[type="radio"][name^="selling_plan_"][value="${planId}"]`
//     );

//     if (planRadio && !planRadio.checked) {
//       planRadio.checked = true;
//       planRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   });
// }
function syncSellingPlanToAllBundles(selectedRadio) {

  // get selected plan position
  const currentPlans = [
    ...selectedRadio
      .closest('.product__subs__plans')
      .querySelectorAll('input[type="radio"][name^="selling_plan_"]')
  ];

  const selectedIndex = currentPlans.indexOf(selectedRadio);

  if (selectedIndex === -1) return;

  document.querySelectorAll('.bundle-wrapper').forEach((bundle, index) => {

    // skip first bundle
    if (index === 0) return;

    const plansContainer = bundle.querySelector(
      '.product__subs__plans:not(.hidden)'
    );

    if (!plansContainer) return;

    const planRadios = [
      ...plansContainer.querySelectorAll(
        'input[type="radio"][name^="selling_plan_"]'
      )
    ];

    const targetRadio = planRadios[selectedIndex];

    if (!targetRadio) return;

    // uncheck old radios
    planRadios.forEach(r => r.checked = false);

    // check matching index radio
    targetRadio.checked = true;

    // update hidden input
    const hidden = bundle.querySelector('.bundle-selling-plan');
    if (hidden) {
      hidden.value = targetRadio.value;
    }

    // trigger UI update
    targetRadio.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  });
}
document.addEventListener('change', function (e) {

  if (e.target.matches('input[type="radio"][name^="selling-plan-group-"]')) {
    const radio = e.target;
    const subsForm = radio.closest('.product__subs');
    if (!subsForm) return;

    const bundle = radio.closest('.bundle-picker__wrapperrr');
    const totalQty = [...items].reduce((sum, item) => {
      return sum + parseInt(item.querySelector('.flavor-qty').value || 0);
    }, 0);

    // BLOCK SUBSCRIPTION WHEN QTY = 1
    if (totalQty === 1 && radio.value) {
      e.preventDefault();
      e.stopImmediatePropagation();

      showMinQtyMessage();
      clickOneTime(bundle);
      return;
    }

    const groupId = radio.value;

    subsForm.querySelectorAll('.product__subs__plans').forEach(p => {
      p.classList.add('hidden');
    });

    if (groupId) {
      const active = subsForm.querySelector(
        `.product__subs__plans[data-group-toggle-ctm="${groupId}"]`
      );
      if (!active) return;

      active.classList.remove('hidden');

      const firstPlan = active.querySelector(
        'input[type="radio"][name^="selling_plan_"]'
      );

      if (firstPlan) {
        firstPlan.checked = true;
        firstPlan.dispatchEvent(new Event('change', { bubbles: true }));

        syncSellingPlanGroupToAllBundles(groupId);
        // syncSellingPlanToAllBundles(firstPlan.value);
        syncSellingPlanToAllBundles(firstPlan);
      }
    } else {
        document.querySelectorAll('.bundle-wrapper').forEach((bundle) => {
          // uncheck selling plan radios
          bundle.querySelectorAll(
            'input[type="radio"][name^="selling_plan_"]'
          ).forEach(radio => {
            radio.checked = false;
          });

          // clear hidden selling plan input
          const hidden = bundle.querySelector('.bundle-selling-plan');
          if (hidden) hidden.value = '';

        });
        syncSellingPlanGroupToAllBundles('');
    }
  }

  // if (e.target.matches('input[type="radio"][name^="selling_plan_"]')) {
  //   const planRadio = e.target;
  //   const bundle = planRadio.closest('.bundle-wrapper');
  //   if (!bundle) return;

  //   const hidden = bundle.querySelector('.bundle-selling-plan');
  //   if (hidden) hidden.value = planRadio.value;

  //   const save = planRadio.dataset.save || '';
  //   const saveBox = planRadio
  //     .closest('.product__subs')
  //     .querySelector('.saved_txt_plan');
  //   console.log(save, "new save code");
  //   if (saveBox) {
  //     if (save) {
  //       saveBox.textContent = `save: ${save}`;
  //       saveBox.classList.remove('hidden');
  //     } else {
  //       saveBox.textContent = '';
  //       saveBox.classList.add('hidden');
  //     }
  //   }
  // }
  if (e.target.matches('input[type="radio"][name^="selling_plan_"]')) {
    const planRadio = e.target;
    const bundle = planRadio.closest('.bundle-wrapper');
    if (!bundle) return;
    console.log(planRadio.value,"planRadio.value");
    const hidden = bundle.querySelector('.bundle-selling-plan');
    if (hidden) {
      hidden.value = planRadio.value;
    }
    const save = planRadio.dataset.save || '';
    const saveBox = planRadio
      .closest('.product__subs')
      .querySelector('.saved_txt_plan');

    console.log(save, "new save code");
    if (saveBox) {
      if (save) {
        saveBox.textContent = `save: ${save}`;
        saveBox.classList.remove('hidden');
      } else {
        saveBox.textContent = '';
        saveBox.classList.add('hidden');
      }
    }
    // ADD THIS HERE
    if (!planRadio.dataset.syncing) {
      planRadio.dataset.syncing = 'true';
      syncSellingPlanToAllBundles(planRadio);
      setTimeout(() => {
        delete planRadio.dataset.syncing;
      }, 0);
    }
  }



});


// new logic qty selector falvor
function clickSubscription(bundle) {
  if (!bundle) return;
  const subscriptionRadio = bundle.querySelector(
    'input[type="radio"][name^="selling-plan-group-"]:not([value=""])'
  );
  if (subscriptionRadio) subscriptionRadio.click();
}

function clickOneTime(bundle) {
  if (!bundle) return;
  const oneTimeRadio = bundle.querySelector(
    'input.one_time_purchase_radio[type="radio"][name^="selling-plan-group-"]'
  );
  if (oneTimeRadio) oneTimeRadio.click();
}

function showMinQtyMessage() {
  const msg = document.querySelector('.min-qty-message');
  if (!msg) return;
  msg.style.display = 'block';
}
function hideMinQtyMessage() {
  const msg = document.querySelector('.min-qty-message');
  if (!msg) return;
  msg.style.display = 'none';
}

function isOneTimePurchase() {
  const oneTime = document.querySelector(
    '.bundle-picker__wrapperrr .one_time_purchase_radio'
  );

  return oneTime && oneTime.checked;
}

function getSelectedSubscriptionPlan() {
  if (isOneTimePurchase()) return null;

  return document.querySelector(
    '.bundle-picker__wrapperrr input[type="radio"][name^="selling_plan_"]:checked'
  );
}

function isSubscriptionSelected() {
  return !isOneTimePurchase() && !!getSelectedSubscriptionPlan();
}

const items = document.querySelectorAll('.bundle-flavor-item');

function activeQtyCount() {
  return [...items].filter(item => {
    return parseInt(item.querySelector('.flavor-qty').value || 0) > 0;
  }).length;
}


function getPurchaseMode() {
  if (isOneTimePurchase()) return 'onetime';

  const plan = getSelectedSubscriptionPlan();
  if (!plan) return 'onetime';

  const freq = plan.dataset.save;
  console.log(plan);
  console.log(freq);
  if (freq === '5%') return 'sub_2_month';
  if (freq === '10%') return 'sub_1_month';
}

function getMessageAndDiscount(mode, totalQty) {
  const cfg = window.DISCOUNT_SETTINGS[mode];
  if (!cfg) return { message: '', discPrc: 0 };

  if (totalQty === 1) return cfg.qty1;
  if (totalQty === 2) return cfg.qty2;
  if (totalQty >= 3 && totalQty <= 5) return cfg.qty3to5;
  return cfg.qtyGt5;
}

function updateFlavorDiscountMessage(totalPrice) {

  const msgWrap = document.querySelector('.flavor_discount_msg_wrp');
  const priceDiscountEls = document.querySelector('[data-flvor-discount-price]');
  const flavorCapsulesEl = document.querySelector(
    '.bundle-flavor-list[data-flavor-capsules="true"]'
  );
  const isFlavorCapsules = !!flavorCapsulesEl;
  if (!msgWrap) return;

  const totalQty = [...items].reduce((sum, item) => {
    return sum + parseInt(item.querySelector('.flavor-qty').value || 0);
  }, 0);

  const bundle = document.querySelector('.bundle-picker__wrapperrr.first_item_favor');
  const bundleOneTimeOnly = document.querySelector('.bundle-flavor-list');
  const hideSubscription = bundleOneTimeOnly.dataset.onetimenlyhidesubscription === "true";
  if (!bundle) return;

  if (totalQty === 1) {
    clickOneTime(bundle);
    bundle.dataset.autoSelected = "false";
  }

  if (totalQty > 1) {
    if (bundle.dataset.autoSelected !== "true") {
      if(!hideSubscription){
        clickSubscription(bundle);
      }
      bundle.dataset.autoSelected = "true";
    }
    hideMinQtyMessage();
  }

  const mode = getPurchaseMode();
  let message = '';
  let discPrc = 0;

  if (mode === 'sub_1_month') {
    ({ message, discPrc } = getMessageAndDiscount(mode, totalQty));
  }
  if (mode === 'sub_2_month') {
    ({ message, discPrc } = getMessageAndDiscount(mode, totalQty));
  }
  if (mode === 'onetime') {
    ({ message, discPrc } = getMessageAndDiscount(mode, totalQty)); 
  }
  if (msgWrap) {
    msgWrap.textContent = message;
  }

  const itemPrc = parseFloat(totalPrice) / parseFloat(totalQty);
  const effectiveQty = isFlavorCapsules
  ? totalQty
  : totalQty - 1;
  const finalSellingPrc = itemPrc * effectiveQty;
  
  
  const totqtyprc = effectiveQty * discPrc * 100;
  const finalPrcWithNewLogic = finalSellingPrc - totqtyprc;

  const priceElNewLogic = document.querySelector('.flavor_rpc_wrp[data-flvor-price]');
  if (!priceElNewLogic) return;

  if (Number(totalPrice) === Number(finalPrcWithNewLogic)) {
    priceElNewLogic.style.display = 'none';
  } else {
    priceElNewLogic.style.display = '';
  }

  const formattedPrice = slate.Currency.formatMoney(
    finalPrcWithNewLogic,
    theme.moneyFormat
  );

  priceDiscountEls.textContent =
  !isFlavorCapsules && finalPrcWithNewLogic > 0 ? `+${formattedPrice}` : formattedPrice;
}



items.forEach(item => {
  const index = item.dataset.bundleIndex;
  const qtyInput = item.querySelector('.flavor-qty');

  const bundleWrapper = document.querySelector(
    `.bundle-picker__wrapperrr[data-bundle-content="${index}"]`
  );
  if (!bundleWrapper) return;

  const hiddenQty = bundleWrapper.querySelector('.bundles-qty-uniq');

  item.querySelector('.qty-minus').addEventListener('click', () => {
    const current = parseInt(qtyInput.value || 0);

    const isComboSet = document.body.classList.contains('ctm_combo-set');
    if (!isComboSet){
     if (current === 1 && activeQtyCount() === 1) return;
    }

    qtyInput.value = Math.max(0, current - 1);
    hiddenQty.value = qtyInput.value;
    setTimeout(() => {
      calculateBundleTotal();
    },300);
    lidProdctToggle();
  });

  item.querySelector('.qty-plus').addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || 0) + 1;
    hiddenQty.value = qtyInput.value;
    setTimeout(() => {
      calculateBundleTotal();
    },300);
    lidProdctToggle();
  });

  qtyInput.addEventListener('change', () => {
    let value = Math.max(0, parseInt(qtyInput.value || 0));

    if (value === 0 && activeQtyCount() === 1) {
      value = 1;
    }

    qtyInput.value = value;
    hiddenQty.value = value;
    setTimeout(() => {
      calculateBundleTotal();
    },300);
  });
});




// =====================================================
// FIX: lidProdctToggle — aktualisiert auch Deckel-Preiszeile
// =====================================================
function lidProdctToggle() {
  const totalTasteFlavorItem = [...items].reduce((sum, item) => {
    return sum + parseInt(item.querySelector('.flavor-qty')?.value || 0);
  }, 0);

  // LID bundle quantity input
  const lidQtyInput = document.querySelector('.ctm_combo-set .hide_prdt .bundles-qty-uniq');
  if (lidQtyInput) {
    if (totalTasteFlavorItem === 0) {
      lidQtyInput.value = 0;
    } else {
      lidQtyInput.value = 1;
    }
  }

  // Deckel-Preiszeile in der Breakdown Box aktualisieren
  const lidPriceSpan = document.querySelector('span[data-lid-price]');
  if (lidPriceSpan) {
    var freeText = lidPriceSpan.getAttribute('data-lid-free-text') || 'GRATIS';
    lidPriceSpan.textContent = totalTasteFlavorItem >= 1 ? freeText : '€ 19.90';
  }

  // flavor message (combo product)
  const comboMsgWrap = document.querySelector('.combo_flavor_discount_msg_wrp');
  if (comboMsgWrap && window.COMBO_MESSAGE_SETTINGS) {
    let message = "";
    if (totalTasteFlavorItem === 0) {
      message = window.COMBO_MESSAGE_SETTINGS.onetime.itemqty0.message;
    } else if (totalTasteFlavorItem === 1) {
      message = window.COMBO_MESSAGE_SETTINGS.onetime.itemqty1.message;
    } else if (totalTasteFlavorItem === 2) {
      message = window.COMBO_MESSAGE_SETTINGS.onetime.itemqty2.message;
    } else if (totalTasteFlavorItem >= 3) {
      message = window.COMBO_MESSAGE_SETTINGS.onetime.itemqtyGt3.message;
    }
    comboMsgWrap.textContent = message;
  }
}


function calculateBundleTotal() {
  let totalPrice = 0;

  totalBreakdownPrice();
  document.querySelectorAll('.bundle-wrapper').forEach((bundle) => {
    const itemPrice = parseInt(bundle.dataset.bundleItemPrice || 0);

    const qtyInput = bundle.querySelector('[data-bundle-qty]');
    const qty = qtyInput ? parseInt(qtyInput.value || 0) : 1;


    if (qty > 0 && itemPrice > 0) {
      totalPrice += itemPrice * qty;
    }
  });
  const priceEl = document.querySelector('.flavor_rpc_wrp[data-flvor-price]');
  if(priceEl){
    priceEl.textContent = slate.Currency.formatMoney(
      totalPrice,
      theme.moneyFormat
    );
    setTimeout(() => {
      updateFlavorDiscountMessage(totalPrice);
    },200);
  }
}


function totalBreakdownPrice() {
  const totalQty = getBundleTotalQty();
  toggleTasteLid(totalQty);
  toggleFlavorBundleRow(totalQty);

  const variantQty = getVariantFlavorTotalQty();
  toggleVariantWrapper(variantQty);

  const { total: variantTotal, ctotal: variantCTotal } = calculateVariantTotal();
  updateVariantBundleUI(variantTotal, variantCTotal);

  const { totalOldPrice } = calculateBundleTotals();

  updateOldPriceUI(totalOldPrice, totalQty);
  updateBundleUI(totalOldPrice, totalQty);


  const mainFinalPrice = getMainPrdctTotal();

  const totalBuilderPrice = getBundleBuilderTotal(totalQty);

  const finalTotal = totalBuilderPrice + variantTotal + mainFinalPrice;


  updateBreakdownUI(finalTotal);
  setTimeout(function(){
    updateComarePrcBreakdownUI();
  },700);
}

function getBundleBuilderTotal(totalQty) {
  let total = 0;

  document.querySelectorAll('.bundle-wrapper').forEach(el => {
    const price = parseInt(el.dataset.bundleBuilderItemPrice || 0, 10);
    total += price;
  });

  const bundlePriceEl = document.querySelector('[data-tab-bundle-item-new-price]');
  const bundleFinalPrice = bundlePriceEl 
    ? parseInt(bundlePriceEl.dataset.tabnewprc || 0)
    : 0;

  if(totalQty > 0){
    total+= bundleFinalPrice;
  }
  

  return total;
}

function getBundleTotalQty() {
  let total = 0;

  document.querySelectorAll('.tabbing_bundle_wrp [data-bundle-qty]')
    .forEach(input => {
      total += parseInt(input.value || 0);
    });
  return total;
}

function toggleTasteLid(totalQty) {
  const el = document.querySelector('.taste_lid_item');
  if (!el) return;

  el.classList.toggle('hidden', totalQty === 0);
}

function toggleFlavorBundleRow(totalQty) {
  const el = document.querySelector('.flvor_bundle_items');
  if (!el) return;

  el.classList.toggle('hidden', totalQty === 0);
}

function toggleVariantWrapper(qty) {
  const el = document.querySelector('.bundle_separate_variant_wrp');
  if (!el) return;

  el.classList.toggle('hidden', qty === 0);
}

function getVariantFlavorTotalQty() {
  let total = 0;

  document.querySelectorAll('.bundle-variant-flavor-list .bundles-variant-qty')
    .forEach(input => {
      total += parseInt(input.value || 0);
    });

  return total;
}

function getMainPrdctTotal() {
  const mainPriceEl = document.querySelector('.main_prdct_couter_row .main_prc');

  return mainPriceEl 
    ? parseInt(mainPriceEl.dataset.maincurrentprc || 0, 10)
    : 0;
}

function calculateVariantTotal() {
  let total = 0;
  let ctotal = 0;

  document.querySelectorAll('.bundle-variant-item').forEach(item => {
    const price = parseInt(item.dataset.varbundlePrc || 0);
    const cprice = parseInt(item.dataset.varbundleCprc || 0);
    const qty = parseInt(item.querySelector('.bundles-variant-qty')?.value || 0);

    if (qty > 0 && price > 0) {
      total += price * qty;
      ctotal += cprice * qty;
    }
  });

  return {total, ctotal};
}

function calculateBundleTotals() {
  let totalOldPrice = 0;

  document.querySelectorAll('.bundle-wrapper').forEach(bundle => {
    const basePrice = parseInt(bundle.dataset.bundleItemPrice || 0);
    const qty = parseInt(bundle.querySelector('[data-bundle-qty]')?.value || 0);
    if (qty > 0) {
      totalOldPrice += basePrice * qty;
    }
  
  });

  return { totalOldPrice };
}

function updateOldPriceUI(total, totalQty) {
  const el = document.querySelector('[data-tab-bundle-item-old-price]');
  const elOldPrc = document.querySelector('.tab-bundle-item-old-price');
  const newEl = document.querySelector('[data-tab-bundle-item-new-price]');
  
  
  if (!el || !total) return;

  const oldPrice = total;
  const newPrice = Number(newEl?.dataset.tabnewprc || 0);

  el.textContent = formatMoneyWithOutCurrency(oldPrice);
  elOldPrc.dataset.oldprc = oldPrice;

  if (oldPrice === newPrice) {
    el.style.display = 'none';
  } else {
    el.style.display = '';
  }
}

function updateVariantBundleUI(total, ctotal) {
  const el = document.querySelector('.variant-bundle-item-new-price');
  if (!el) return;

  const elOld = document.querySelector('.variant-bundle-item-old-price');
  if (!elOld) return;

  
  el.innerHTML = formatMoney(total);
  elOld.innerHTML = formatMoneyWithOutCurrency(ctotal);
  elOld.dataset.oldprc = ctotal;
}

// =====================================================
// FIX: updateBreakdownUI — addiert Deckelpreis falls < 3 Kapseln
// =====================================================
function updateBreakdownUI(total) {
  const el = document.querySelector('.price-total .new-total');
  if (!el) return;

  // Anzahl gewählter Kapseln
  var totalFlavors = 0;
  document.querySelectorAll('[data-flavor-qty]').forEach(function(input) {
    totalFlavors += parseInt(input.value) || 0;
  });

  // 19.90 CHF (= 1990 Cents) addieren falls < 3 Kapseln gewählt
  var lidCents = totalFlavors === 0 ? 0 : (totalFlavors >= 1 ? 0 : 1990);
  console.log(lidCents);
  var finalTotal = total + lidCents;

  el.innerHTML = formatMoney(finalTotal);
}

function updateComarePrcBreakdownUI() {
  const el = document.querySelector('.price-total .old-total');
  if (!el) return;

  var total = 0;

  document.querySelectorAll('.price-row:not(.hidden) [data-oldprc]').forEach(item => {
    const price = parseInt(item.dataset.oldprc || 0, 10);
    total += price;
  });
  console.log(total);
  el.innerHTML = formatMoney(total);
}

function updateBundleUI(totalPrice, totalQty) {
  const el = document.querySelector('[data-tab-bundle-item-new-price]');
  if (!el || totalQty === 0) return;

  const mode = getPurchaseMode();
  let { message, discPrc } = getMessageAndDiscount(mode, totalQty);
  console.log(discPrc);
  const itemPrice = totalPrice / totalQty;
  var effectiveQty = totalQty;

  const baseTotal = itemPrice * effectiveQty;
  const discountTotal = effectiveQty * discPrc * 100;

  let finalPrice = baseTotal - discountTotal;

  el.dataset.tabnewprc = finalPrice;
  el.innerHTML = formatMoney(finalPrice);
  
}

function formatMoneyWithOutCurrency(amount) {
  if (window.slate && slate.Currency) {
    return slate.Currency.formatMoney(amount, "{{amount}}");
  }
}
function formatMoney(amount) {
  if (window.slate && slate.Currency) {
    return slate.Currency.formatMoney(amount, theme.moneyFormat);
  }
}


document.addEventListener("DOMContentLoaded", function () {
  // Initial load
  calculateBundleTotal();

  // Listen to qty changes
  document.querySelectorAll('[data-bundle-qty]').forEach((input) => {
    input.addEventListener("change", calculateBundleTotal);
    input.addEventListener("keyup", calculateBundleTotal);
  });
});


// count each falvor price
document.addEventListener("DOMContentLoaded", function () {

  // combo set product
    lidProdctToggle();


  function calculateSubscriptionPrice(basePrice, saveType, saveRaw) {
    let price = basePrice;

    if (saveType === "percentage") {
      price = basePrice - (basePrice * saveRaw / 100);
    } else if (saveType === "amount") {
      price = basePrice - saveRaw;
    }

    return Math.round(price);
  }

  function updateBundlePrices() {

    const isOneTime = isOneTimePurchase();
    const isSubscription = isSubscriptionSelected();

    let saveType = null;
    let saveRaw = 0;

    if (isSubscription) {
      const plan = getSelectedSubscriptionPlan();
      saveType = plan.dataset.saveType;
      saveRaw  = parseFloat(plan.dataset.saveRaw || 0);
    }

    document.querySelectorAll('.bundle-picker__wrapperrr .bundle-wrapper').forEach((bundle) => {

      if (!bundle.dataset.bundleItemPriceBase) {
        bundle.dataset.bundleItemPriceBase = bundle.dataset.bundleItemPrice;
      }

      const basePrice = parseInt(bundle.dataset.bundleItemPriceBase, 10);
      if (!basePrice) return;

      if (isOneTime) {
        bundle.dataset.bundleItemPrice = basePrice;
        return;
      }

      if (isSubscription) {
        bundle.dataset.bundleItemPrice = calculateSubscriptionPrice(
          basePrice,
          saveType,
          saveRaw
        );
      }
    });

    if (typeof calculateBundleTotal === "function") {
      calculateBundleTotal();
    }
  }
  updateBundlePrices();
 document.addEventListener("change", function (e) {

    if (
      e.target.matches('input[type="radio"][name^="selling_plan_"]') ||
      e.target.matches('input[type="radio"][name^="selling-plan-group-"]')
    ) {
      updateBundlePrices();
    }

  });


});

// sync bundle options 
$(document).on(
  'click',
  '.bundle-color-swatch .radio__fieldset .swatch__label',
  function (e) {

    const label = e.target.closest('.swatch__label');
    if (!label) return;

    const currentBundle = label.closest('.sync_prdc_optn');
    if (!currentBundle) return;

    const colorValue = label.dataset.swatch;
    if (!colorValue) return;

    document.querySelectorAll('.sync_prdc_optn').forEach(bundle => {
      if (bundle === currentBundle) return;

      const matchingLabel = bundle.querySelector(
        `.swatch__label[data-swatch="${CSS.escape(colorValue)}"]`
      );

      if (matchingLabel) {
        matchingLabel.click();
      }
    });
  }
);

function syncGlobalSoldoutSwatches() {
  const soldOutMap = new Set();

  document.querySelectorAll('.sync_prdc_optn .swatch__label').forEach(label => {
    const value = label.dataset.swatch;
    const available = label.dataset.variantAvailable === 'true';
    const qty = parseInt(label.dataset.vqty || 0, 10);
    const policy = label.dataset.vpolicy;

    if (!available || (qty <= 0 && policy === 'deny')) {
      soldOutMap.add(value);
    }
  });

  document.querySelectorAll('.sync_prdc_optn .swatch__label').forEach(label => {
    const value = label.dataset.swatch;
    if (!soldOutMap.has(value)) return;

    label.dataset.variantAvailable = 'false';
    label.classList.add('is-soldout');

    const input = label
      .closest('.swatch__button')
      ?.querySelector('input[type="radio"]');

    if (input) {
      input.classList.remove('swatch__input--bundle');
      input.disabled = true;
      input.checked = false;
    }
  });
}

syncGlobalSoldoutSwatches();


// info icon
document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll("[data-tooltip-trigger]");
  triggers.forEach(function(trigger){
    const tooltip = trigger.querySelector(".flavor-info-tooltip");
    const closeBtn = trigger.querySelector(".tooltip-close");
    trigger.addEventListener("click", function(e){
      e.stopPropagation();
      document.querySelectorAll(".flavor-info-tooltip").forEach(t => {
        if(t !== tooltip){
          t.classList.remove("active");
        }
      });
      tooltip.classList.toggle("active");
    });
    closeBtn.addEventListener("click", function(e){
      e.stopPropagation();
      tooltip.classList.remove("active");
    });
  });
  document.addEventListener("click", function(){
    document.querySelectorAll(".flavor-info-tooltip").forEach(t => {
      t.classList.remove("active");
    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
    if (
        document.body.classList.contains("ctm_spark-set-with-co2") ||
        document.body.classList.contains("ctm_spark-set-with-co2-test")
    ) {
        const checkedRadio = document.querySelector(
            'input.ctm_set_co2_variant[type="radio"]:checked'
        );

        if (checkedRadio) {
            const vid = checkedRadio.getAttribute("data-vid");

            // Main product form hidden input
            const hiddenInput = document.querySelector(
                'input[name="id"][data-custm-co2-select]'
            );

            if (hiddenInput && vid) {
                hiddenInput.value = vid;
            }

            // Sticky ATC hidden input
            const stickyInput = document.querySelector(
                '.sticky-atc__button form [name="id"][data-custm-co2-select]'
            );

            if (stickyInput) {
                stickyInput.value = vid;
            }

            console.log("Initial CO2 variant set:", vid);
        }
    }
});